import { Component, Inject } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { ApplicationFacade } from '@ridango/components';
import Env from '@ridango/core/env';

@Component({
    selector: 'gl-select-new-payment-method-modal',
    templateUrl: './select-new-payment-method-modal.component.html',
    styleUrls: ['./select-new-payment-method-modal.component.scss']
})
export class SelectNewPaymentMethodModalComponent {
    public assetsPath$ = this.applicationFacade.assetsPath$;

    constructor(
        private modalCtrl: ModalController,
        private applicationFacade: ApplicationFacade,
        @Inject('ENV') public env: Env
    ) {}

    savePaymentMethodsConfirm() {
        this.modalCtrl.dismiss(true, 'cancel');
    }

    cancel() {
        this.modalCtrl.dismiss(false, 'cancel');
    }

    close() {
        this.modalCtrl.dismiss(null, 'cancel');
    }
}
